<template>
  <div
    class="archax-sticky-header"
    ref="archaxBanner"
    v-if="!isWidget && geoIsUK"
  >
    <p>
      Don't invest unless you're prepared to lose all the money you invest. This
      is a high-risk investment and you should not expect to be protected if
      something goes wrong.
      <a
        href="https://banxa.com/due-diligence/"
        target="_blank"
        rel="noopener noreferrer"
      >Take 2 min to learn more.</a
      >
    </p>
  </div>
</template>

<script setup>
import {
 ref, watch, computed,
} from 'vue';
import { useArchaxStore } from '@/stores/custom/ArchaxStore';
import useWidgetCheck from '@/composables/router/useWidgetCheck';
import { checkGeo } from '@/composables/helpers/useDetectedGeo';

const { checkWidget } = useWidgetCheck();

const archaxStore = useArchaxStore();
const archaxBanner = ref(null);

const geoIsUK = computed(() => checkGeo('GB'));
const isWidget = computed(() => checkWidget());

const handleWindowResize = () => {
  archaxStore.setBannerHeight(archaxBanner.value.clientHeight);
  window.addEventListener('resize', () => {
    archaxStore.setBannerHeight(archaxBanner.value.clientHeight);
  });
};

watch(
  () => geoIsUK.value,
  () => {
    if (geoIsUK.value) {
      handleWindowResize();
    }
  },
  { deep: true },
);
</script>

<style lang="scss" scoped>
.archax-sticky-header {
  top: 0;
  left: 0;
  right: 0;
  padding: 1rem;
  min-height: 40px;
  background: #a393e2;
  font-size: 0.75rem;
  position: fixed;
  display: flex;
  z-index: 18;

  p,
  p > a {
    text-align: left;
    color: #2d2d2d;
  }

  a {
    font-weight: 700;
  }
}
</style>
